import * as React from 'react'
import { View, ViewStyle } from 'react-native'
import { useBreakpoints, ResponsiveValue } from './hooks/useBreakpoints'
import { spacing } from './types'

type AlignX = 'left' | 'center' | 'right' | 'space-between' | 'space-around'
type AlignY = 'top' | 'center' | 'bottom' | 'stretch'

interface InlineProps {
	children: React.ReactNode
	gap?: keyof typeof spacing
	alignX?: AlignX | ResponsiveValue<AlignX>
	alignY?: AlignY | ResponsiveValue<AlignY>
	style?: ViewStyle
}

const alignXToJustify = {
	left: 'flex-start',
	center: 'center',
	right: 'flex-end',
	'space-between': 'space-between',
	'space-around': 'space-around',
} as const

const alignYToAlign = {
	top: 'flex-start',
	center: 'center',
	bottom: 'flex-end',
	stretch: 'stretch',
} as const

export function Inline({ children, gap = 'md', alignX, alignY, style }: InlineProps) {
	const { value } = useBreakpoints()
	const gapValue = spacing[gap]

	const currentAlignX = alignX ? (typeof alignX === 'string' ? alignX : value(alignX)) : 'left'
	const currentAlignY = alignY ? (typeof alignY === 'string' ? alignY : value(alignY)) : 'stretch'

	return (
		<View
			style={[
				{
					flexDirection: 'row',
					flexWrap: 'wrap',
					gap: gapValue,
					justifyContent: alignXToJustify[currentAlignX],
					alignItems: alignYToAlign[currentAlignY],
				},
				style,
			]}
		>
			{children}
		</View>
	)
}
